import React from 'react';
import { Invoice } from '../../Invoices.types';
import * as S from './InvoiceListItem.styles';
import { DownloadIcon, SmallChevronIcon } from '@/components/UI/Icons/Icons';
import { InvoiceStatusBadge } from '@/features/Profile/sections/Invoices/components/InvoiceStatusBadge';

interface InvoiceListItemProps {
  invoice: Invoice;
  onShowDetails: (invoice: Invoice) => void;
}

export function InvoiceListItem({
  invoice,
  onShowDetails,
}: InvoiceListItemProps) {
  function handleDownloadClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.stopPropagation();
  }

  return (
    <S.Item onClick={() => onShowDetails(invoice)}>
      <S.Content>
        <S.TopRow>
          <S.Service title={invoice.service}>{invoice.service}</S.Service>
          <S.Amount>{invoice.formattedAmount}</S.Amount>
        </S.TopRow>

        <S.BottomRow>
          <S.Number title={invoice.number}>{invoice.number}</S.Number>
          <InvoiceStatusBadge status={invoice.status} />
        </S.BottomRow>
      </S.Content>

      <S.Icons>
        <S.DownloadSlot>
          {invoice.canDownload && (
            <S.Download
              href={invoice.printUrl}
              target="_blank"
              onClick={handleDownloadClick}
            >
              <DownloadIcon width={20} height={20} />
            </S.Download>
          )}
        </S.DownloadSlot>

        <S.Chevron>
          <SmallChevronIcon width={12} height={14} />
        </S.Chevron>
      </S.Icons>
    </S.Item>
  );
}
